import React from 'react';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import NewCommissionModal from "./newCommissionModal";
import {Heading, Button, Table, Alert } from 'arag-ui-lib';
import { TERTIARY, RIGHT, ERROR, HEADING_3 } from '../../../helpers/constants';
import { getStepMessage } from '../../../helpers/premiumSettingsFunctions';
import { formatSolicitorTableLabel } from '../../../helpers/functions';

const Step3 = (props) => {
    const {
        currentStep,
        openSolicitorModal,
        changeStoreSettings,
        changeLawsysFirmState,
        onSuggestionChange, 
        onSuggestionSelected,
        addSolicitor,
        solicitorsList,
        lawsysFirms,
        removeSolicitor,
        step3WarningMsg,
        stepMessages,
        solicitorGroupAragProviderId,
        commissionAddDisabled,
    } = props;


    if(currentStep !== 3)
        return null;

    const data = solicitorsList.map((solicitor, index) => {
        return {
            agent: solicitor.name,
            aragProvider: solicitor.aragProvider,
            index: index
        };
    });
    const stepMessage = getStepMessage('3', stepMessages);
    return (
        <div>
            {
                openSolicitorModal
                ?
                    <NewCommissionModal 
                        isOpen={openSolicitorModal}
                        onSuggestionChange={onSuggestionChange}
                        onSuggestionSelected={onSuggestionSelected}
                        submitHandler={addSolicitor}
                        solicitorsList={solicitorsList}
                        lawsysFirms={lawsysFirms}
                        solicitorGroupAragProviderId={solicitorGroupAragProviderId}
                        onClose={() => {
                                changeStoreSettings('openSolicitorModal', false);
                                changeLawsysFirmState('suggestionFieldValue', '');
                                changeLawsysFirmState('selectedLawsysFirmsDropdown', []);
                                changeLawsysFirmState('lawsysFirmsFiltered', []);
                            }
                        }
                        modalTestId={'edit-application-premium-setting-commissions-new-commission-modal-close'}
                        formGroupLabelTestId={'edit-application-premium-setting-commissions-new-commission-modal-agent-text'}
                        formGroupInputTestId={'edit-application-premium-setting-commissions-new-commission-modal-agent-select'}
                        buttonTestId={'edit-application-premium-setting-commissions-new-commission-modal-add'}
                        linkTestId={'edit-application-premium-setting-commissions-new-commission-modal-cancel'}
                    />
                :
                    null
            }
            <Heading
                variant={HEADING_3}
                title={stepMessage}
                headingTestId={'edit-application-premium-setting-instructions'}
            />
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                <Button
                    label={CONTENT_STRINGS.ADD_NEW_COMMISSION}
                    onClick={() => {
                        changeStoreSettings('openSolicitorModal', true);
                        changeLawsysFirmState('suggestionFieldValue', '');
                        changeLawsysFirmState('suggestions',[]);
                    }}
                    variant={TERTIARY}
                    arrowDirection={RIGHT}
                    disabled={commissionAddDisabled}
                    buttonTestId={'edit-application-premium-setting-commissions-commissions'}
                />
                <Table 
                    columns={[
                        {
                            propertyName: 'agent',
                            header: CONTENT_STRINGS.AGENT,
                            id: 'agent',
                            formatter: (row) => formatSolicitorTableLabel({ label: row.agent, aragProvider: row.aragProvider }),
                        }
                    ]}
                    data={data}
                    hasActions
                    actions={[{
                        key: 'removeAgent',
                        label: CONTENT_STRINGS.REMOVE,
                        callback: (row) => removeSolicitor(row.index),
                        actionTitle: CONTENT_STRINGS.ACTIONS,
                    }]}
                    striped
                    tableWrapperTestId={'edit-application-premium-setting-commissions-commissions'}
                />
            </div>
            { 
                step3WarningMsg !== '' && (solicitorsList.length === 0) 
                    ? <Alert variant={ERROR} label={step3WarningMsg} /> 
                    : null 
            }
        </div>
    )
};

export default Step3;